import React from "react";
import { useTranslation } from "react-i18next";
import { CheckCircle2, MailWarning } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useSupportStore } from "../store/support-store";

export const SupportSuccessCard: React.FC = () => {
  const { t } = useTranslation();
  const { lastSubmission, clearLastSubmission } = useSupportStore();

  if (!lastSubmission) return null;

  return (
    <div className="flex flex-col items-center gap-5 rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-emerald-500/10 dark:bg-emerald-500/20">
        <CheckCircle2 className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />
      </div>

      <div className="flex flex-col items-center gap-2">
        <h2 className="text-xl font-semibold text-foreground">
          {t("support.success.title")}
        </h2>
        {typeof lastSubmission.ticketNumber === "number" && (
          <span className="inline-flex w-fit items-center rounded-full border border-border bg-muted px-3 py-1 text-xs font-semibold tracking-wide text-foreground">
            {t("support.success.ticketNumber", {
              number: lastSubmission.ticketNumber,
            })}
          </span>
        )}
        <p className="text-sm text-muted-foreground">
          {t("support.success.description", { email: lastSubmission.email })}
        </p>
        <p className="text-sm font-medium text-foreground">
          {t(lastSubmission.categoryLabelKey)} —{" "}
          {t(lastSubmission.issueLabelKey)}
        </p>
      </div>

      {!lastSubmission.emailSent && (
        <div className="flex items-center gap-2 rounded-lg bg-amber-500/10 px-3 py-2 text-sm text-amber-700 dark:bg-amber-500/15 dark:text-amber-400">
          <MailWarning className="h-4 w-4 shrink-0" />
          {t("support.success.emailNotSent")}
        </div>
      )}

      <Button
        variant="outline"
        size="md"
        onClick={clearLastSubmission}
        className="dark:border-border dark:bg-muted/50 dark:text-foreground dark:hover:bg-muted"
      >
        {t("support.success.newRequest")}
      </Button>
    </div>
  );
};
